module.exports = __webpack_public_path__ + "static/media/model-04.26d0e864.jpg";